
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, watch, reactive, onMounted, defineComponent} from 'vue';
import {getSkiTicketBaseConfig} from "../../utils/config-helper";
import {addParamsToUrl, assertData, fetcher} from "../../utils/utils";
import {PriceTendencyStruct, PriceTendencyPriceStruct} from "../../utils/structs";
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';
import LoadingSpinner from "../loading/LoadingSpinner.vue";
import axios from 'axios';

export default defineComponent({
    name: "PriceTendency",
    components: {
        LoadingSpinner,
        Popper
    },
    props: {
        ticketId: {
            type: String,
            required: true,
        },
        selectedDateStart: {
            type: String,
            required: true,
        },
        selectedDateEnd: {
            type: String,
            required: true,
        }
    },
    emits: ['onHideServiceView', 'onHidePriceTendency', 'noAvailableDates','presalesExpiredMessage', 'isLoadingPrice'],
    setup(props, {emit}) {
        const priceTendencyConfig = ref<object>({});
        const isLoadingPrice = ref<boolean>(false);
        let controller;
        let priceTendencyController;
        const fetchData = async () => {
            if(controller) {
                controller.abort();
            }
            controller = new AbortController();
            const params = {
                ticketId: props.ticketId,
                ...(props.selectedDateStart !== "" && {selectedDateStart: props.selectedDateStart}),
                ...(props.selectedDateEnd !== "" && {selectedDateEnd: props.selectedDateEnd}),
            };
            isLoadingPrice.value = true;
            emit('isLoadingPrice', true);

            let priceUrl = getSkiTicketBaseConfig().priceTendencyPrice;
            priceUrl = addParamsToUrl(priceUrl, new URLSearchParams(params));

            if (typeof priceUrl === 'object') {
                priceUrl = priceUrl.href;
            }

            await axios({
                method: 'GET',
                url: priceUrl,
                signal: controller.signal,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }}).then((res) => res.data).then((result) => {
                assertData(result, PriceTendencyPriceStruct, 'PriceTendencyPrice: fetchData Error', '<small>URL: ' + priceUrl + '</small>', 'danger');
                priceTendencyConfig.value =
                    {
                        ...priceTendencyConfig.value,
                        ...result.data
                    };
                if(result.data.hideServiceView !== undefined) {
                    emit('onHideServiceView', result.data.hideServiceView);
                }
                if(result.data.noAvailableDates) {
                    emit('noAvailableDates', result.data.noAvailableDates);
                } else {
                    emit('noAvailableDates', false);
                }
                if(result.data.presalesExpiredMessage) {
                    emit('presalesExpiredMessage', result.data.presalesExpiredMessage);
                } else {
                    emit('presalesExpiredMessage', '');
                }
                isLoadingPrice.value = false;
                emit('isLoadingPrice', false);

            }).catch((error) => {
                if(error.name === 'CanceledError') {
                    return;
                }
                isLoadingPrice.value = false;
                emit('isLoadingPrice', false);

                console.log(error);
            });


            let url = getSkiTicketBaseConfig().priceTendency;
            url = addParamsToUrl(url, new URLSearchParams(params));
            if (typeof url === 'object') {
                url = url.href;
            }
            if(priceTendencyController) {
                priceTendencyController.abort();
            }
            priceTendencyController = new AbortController();

            await axios({
                method: 'GET',
                url: url,
                signal: controller.signal,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }}).then((res) => res.data).then((result) => {
                assertData(result, PriceTendencyStruct, 'PriceTendency: fetchData Error', '<small>URL: ' + url + '</small>', 'danger');
                priceTendencyConfig.value =
                    {
                        ...priceTendencyConfig.value,
                        ...result.data
                    };
                //needed for priceTendencyLegend
                if(!priceTendencyConfig.value || priceTendencyConfig.value?.hidePriceTendency) {
                    emit('onHidePriceTendency', true);
                } else {
                    emit('onHidePriceTendency', false);
                }
            }).catch((error) => {
                console.log(error);
            });
        };


        const stylePercentage = (percentage) => {
            //different percentage different color
            if(percentage < 20) {
                return {
                    width: percentage + '%',
                    backgroundColor: 'var(--price-tendency-high)'
                }
            } else if(percentage < 40) {
                return {
                    width: percentage + '%',
                    backgroundColor: 'var(--price-tendency-rather-high)'
                }
            } else if(percentage < 60) {
                return {
                    width: percentage + '%',
                    backgroundColor: 'var(--price-tendency-neutral)'
                }
            } else if(percentage < 80) {
                return {
                    width: percentage + '%',
                    backgroundColor: 'var(--price-tendency-rather-low)'
                }
            } else {
                return {
                    width: percentage + '%',
                    backgroundColor: 'var(--price-tendency-low)'
                }
            }
        };

        onMounted(() => {
            fetchData();
        });

        watch(() => [props.selectedDateStart, props.selectedDateEnd], (first, second) => {
            fetchData();
        });

        return {
            priceTendencyConfig,
            stylePercentage,
            isLoadingPrice,
            translate
        }
    }
})
